/* eslint-disable */
// this is an auto generated file. This will be overwritten

export const createMachine = /* GraphQL */ `
  mutation CreateMachine(
    $input: CreateMachineInput!
    $condition: ModelMachineConditionInput
  ) {
    createMachine(input: $input, condition: $condition) {
      id
      Name
      Type
      MachineCategory
      MachineCategoryText
      MachineType
      MachineTypeText
      CustomerName
      CustomerMachineID
      Equipment
      MakerID
      MakerText
      ModelNumber
      PurchasedDate
      SystemOil
      SystemOilUnit
      SystemOilUnitText
      MachineMemo
      TotalOperatingTime
      TotalOperatingTimeUnit
      TotalOperatingTimeUnitText
      OperatingTime
      OperatingTimeUnit
      OperatingTimeUnitText
      OverhaulDate
      SinceOverhaulTime
      SinceOverhaulTimeUnit
      SinceOverhaulTimeUnitText
      OilmakerID
      OilmakerText
      OilModelNumber
      OilGrade
      OilGradeText
      OilTypeCategory
      OilTypeCategoryText
      OilType
      OilTypeText
      OilProperty
      OilPropertyText
      isHazardousMaterials
      HazardousMaterialsDetail
      isAccept
      OilChangeDate
      OilChange
      OilChangeUnit
      OilChangeUnitText
      OilUsageTime
      OilUsageTimeUnit
      OilUsageTimeUnitText
      UseFilter
      FilterUsageTime
      FilterUsageTimeUnit
      FilterUsageTimeUnitText
      SamplingBy
      SamplingPlace
      AnalizeTypeGroup
      AnalizeType
      AnalizeSet
      AnalizeItems
      AnalizeItemSub
      AnalizePurpose
      StandardValue
      Surplus
      Filter
      OfficeID
      Status
      LatestOrderNumber
      LatestOrderAt
      LatestOperatingTime
      LatestOperatingTimeUnit
      LatestOperatingTimeUnitText
      MountedMachineID
      MountPosition
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const updateMachine = /* GraphQL */ `
  mutation UpdateMachine(
    $input: UpdateMachineInput!
    $condition: ModelMachineConditionInput
  ) {
    updateMachine(input: $input, condition: $condition) {
      id
      Name
      Type
      MachineCategory
      MachineCategoryText
      MachineType
      MachineTypeText
      CustomerName
      CustomerMachineID
      Equipment
      MakerID
      MakerText
      ModelNumber
      PurchasedDate
      SystemOil
      SystemOilUnit
      SystemOilUnitText
      MachineMemo
      TotalOperatingTime
      TotalOperatingTimeUnit
      TotalOperatingTimeUnitText
      OperatingTime
      OperatingTimeUnit
      OperatingTimeUnitText
      OverhaulDate
      SinceOverhaulTime
      SinceOverhaulTimeUnit
      SinceOverhaulTimeUnitText
      OilmakerID
      OilmakerText
      OilModelNumber
      OilGrade
      OilGradeText
      OilTypeCategory
      OilTypeCategoryText
      OilType
      OilTypeText
      OilProperty
      OilPropertyText
      isHazardousMaterials
      HazardousMaterialsDetail
      isAccept
      OilChangeDate
      OilChange
      OilChangeUnit
      OilChangeUnitText
      OilUsageTime
      OilUsageTimeUnit
      OilUsageTimeUnitText
      UseFilter
      FilterUsageTime
      FilterUsageTimeUnit
      FilterUsageTimeUnitText
      SamplingBy
      SamplingPlace
      AnalizeTypeGroup
      AnalizeType
      AnalizeSet
      AnalizeItems
      AnalizeItemSub
      AnalizePurpose
      StandardValue
      Surplus
      Filter
      OfficeID
      Status
      LatestOrderNumber
      LatestOrderAt
      LatestOperatingTime
      LatestOperatingTimeUnit
      LatestOperatingTimeUnitText
      MountedMachineID
      MountPosition
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const deleteMachine = /* GraphQL */ `
  mutation DeleteMachine(
    $input: DeleteMachineInput!
    $condition: ModelMachineConditionInput
  ) {
    deleteMachine(input: $input, condition: $condition) {
      id
      Name
      Type
      MachineCategory
      MachineCategoryText
      MachineType
      MachineTypeText
      CustomerName
      CustomerMachineID
      Equipment
      MakerID
      MakerText
      ModelNumber
      PurchasedDate
      SystemOil
      SystemOilUnit
      SystemOilUnitText
      MachineMemo
      TotalOperatingTime
      TotalOperatingTimeUnit
      TotalOperatingTimeUnitText
      OperatingTime
      OperatingTimeUnit
      OperatingTimeUnitText
      OverhaulDate
      SinceOverhaulTime
      SinceOverhaulTimeUnit
      SinceOverhaulTimeUnitText
      OilmakerID
      OilmakerText
      OilModelNumber
      OilGrade
      OilGradeText
      OilTypeCategory
      OilTypeCategoryText
      OilType
      OilTypeText
      OilProperty
      OilPropertyText
      isHazardousMaterials
      HazardousMaterialsDetail
      isAccept
      OilChangeDate
      OilChange
      OilChangeUnit
      OilChangeUnitText
      OilUsageTime
      OilUsageTimeUnit
      OilUsageTimeUnitText
      UseFilter
      FilterUsageTime
      FilterUsageTimeUnit
      FilterUsageTimeUnitText
      SamplingBy
      SamplingPlace
      AnalizeTypeGroup
      AnalizeType
      AnalizeSet
      AnalizeItems
      AnalizeItemSub
      AnalizePurpose
      StandardValue
      Surplus
      Filter
      OfficeID
      Status
      LatestOrderNumber
      LatestOrderAt
      LatestOperatingTime
      LatestOperatingTimeUnit
      LatestOperatingTimeUnitText
      MountedMachineID
      MountPosition
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const createParts = /* GraphQL */ `
  mutation CreateParts(
    $input: CreatePartsInput!
    $condition: ModelPartsConditionInput
  ) {
    createParts(input: $input, condition: $condition) {
      id
      Name
      MachineID
      CustomerPartsID
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const updateParts = /* GraphQL */ `
  mutation UpdateParts(
    $input: UpdatePartsInput!
    $condition: ModelPartsConditionInput
  ) {
    updateParts(input: $input, condition: $condition) {
      id
      Name
      MachineID
      CustomerPartsID
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const deleteParts = /* GraphQL */ `
  mutation DeleteParts(
    $input: DeletePartsInput!
    $condition: ModelPartsConditionInput
  ) {
    deleteParts(input: $input, condition: $condition) {
      id
      Name
      MachineID
      CustomerPartsID
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const createMachineLog = /* GraphQL */ `
  mutation CreateMachineLog(
    $input: CreateMachineLogInput!
    $condition: ModelMachineLogConditionInput
  ) {
    createMachineLog(input: $input, condition: $condition) {
      id
      MachineID
      Type
      Description
      Detail
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const updateMachineLog = /* GraphQL */ `
  mutation UpdateMachineLog(
    $input: UpdateMachineLogInput!
    $condition: ModelMachineLogConditionInput
  ) {
    updateMachineLog(input: $input, condition: $condition) {
      id
      MachineID
      Type
      Description
      Detail
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const deleteMachineLog = /* GraphQL */ `
  mutation DeleteMachineLog(
    $input: DeleteMachineLogInput!
    $condition: ModelMachineLogConditionInput
  ) {
    deleteMachineLog(input: $input, condition: $condition) {
      id
      MachineID
      Type
      Description
      Detail
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const createSample = /* GraphQL */ `
  mutation CreateSample(
    $input: CreateSampleInput!
    $condition: ModelSampleConditionInput
  ) {
    createSample(input: $input, condition: $condition) {
      id
      SamplingAt
      SamplerName
      MachineID
      Name
      AnalizeTypeGroup
      AnalizeTypeGroupName
      CustomerName
      CustomerMachineID
      MachineCategory
      MachineCategoryText
      MachineType
      MachineTypeText
      Equipment
      MakerID
      MakerText
      ModelNumber
      PurchasedDate
      SystemOil
      SystemOilUnit
      SystemOilUnitText
      MachineMemo
      TotalOperatingTime
      TotalOperatingTimeUnit
      TotalOperatingTimeUnitText
      OperatingTime
      OperatingTimeUnit
      OperatingTimeUnitText
      OverhaulDate
      SinceOverhaulTime
      SinceOverhaulTimeUnit
      SinceOverhaulTimeUnitText
      ParentCustomerMachineID
      ParentEquipment
      ParentMakerID
      ParentMakerText
      ParentModelNumber
      ParentPurchasedDate
      ParentTotalOperatingTime
      ParentTotalOperatingTimeUnit
      ParentTotalOperatingTimeUnitText
      ParentSinceOverhaulTime
      ParentSinceOverhaulTimeUnit
      ParentSinceOverhaulTimeUnitText
      OilmakerID
      OilmakerText
      OilModelNumber
      OilGrade
      OilGradeText
      OilTypeCategory
      OilTypeCategoryText
      OilType
      OilTypeText
      OilProperty
      OilPropertyText
      isHazardousMaterials
      HazardousMaterialsDetail
      HazardousMaterialsConfirmed
      TrackingNumber
      OilChangeDate
      isOilChange
      OilChange
      OilChangeUnit
      OilChangeUnitText
      OilUsageTime
      OilUsageTimeUnit
      OilUsageTimeUnitText
      UseFilter
      FilterUsageTime
      FilterUsageTimeUnit
      FilterUsageTimeUnitText
      OilCondition
      OilConditionText
      AnalizeType
      AnalizeTypeName
      AnalizeSet
      AnalizeSetName
      AnalizeItems
      AnalizeItemNames
      AnalizeItemSub
      AnalizePurpose
      StandardValue
      StandardValueName
      Surplus
      Filter
      LatestOrderNumber
      OfficeID
      BottleCount
      ApplicationID
      Status
      Memo
      SamplingBy
      SamplingPlace
      MountPosition
      DeliveryPeriod
      Quantity
      Price
      Report
      Opinion
      SampleID
      SameCount
      Message
      Discount
      Tax
      Fee
      SampleNumber
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const updateSample = /* GraphQL */ `
  mutation UpdateSample(
    $input: UpdateSampleInput!
    $condition: ModelSampleConditionInput
  ) {
    updateSample(input: $input, condition: $condition) {
      id
      SamplingAt
      SamplerName
      MachineID
      Name
      AnalizeTypeGroup
      AnalizeTypeGroupName
      CustomerName
      CustomerMachineID
      MachineCategory
      MachineCategoryText
      MachineType
      MachineTypeText
      Equipment
      MakerID
      MakerText
      ModelNumber
      PurchasedDate
      SystemOil
      SystemOilUnit
      SystemOilUnitText
      MachineMemo
      TotalOperatingTime
      TotalOperatingTimeUnit
      TotalOperatingTimeUnitText
      OperatingTime
      OperatingTimeUnit
      OperatingTimeUnitText
      OverhaulDate
      SinceOverhaulTime
      SinceOverhaulTimeUnit
      SinceOverhaulTimeUnitText
      ParentCustomerMachineID
      ParentEquipment
      ParentMakerID
      ParentMakerText
      ParentModelNumber
      ParentPurchasedDate
      ParentTotalOperatingTime
      ParentTotalOperatingTimeUnit
      ParentTotalOperatingTimeUnitText
      ParentSinceOverhaulTime
      ParentSinceOverhaulTimeUnit
      ParentSinceOverhaulTimeUnitText
      OilmakerID
      OilmakerText
      OilModelNumber
      OilGrade
      OilGradeText
      OilTypeCategory
      OilTypeCategoryText
      OilType
      OilTypeText
      OilProperty
      OilPropertyText
      isHazardousMaterials
      HazardousMaterialsDetail
      HazardousMaterialsConfirmed
      TrackingNumber
      OilChangeDate
      isOilChange
      OilChange
      OilChangeUnit
      OilChangeUnitText
      OilUsageTime
      OilUsageTimeUnit
      OilUsageTimeUnitText
      UseFilter
      FilterUsageTime
      FilterUsageTimeUnit
      FilterUsageTimeUnitText
      OilCondition
      OilConditionText
      AnalizeType
      AnalizeTypeName
      AnalizeSet
      AnalizeSetName
      AnalizeItems
      AnalizeItemNames
      AnalizeItemSub
      AnalizePurpose
      StandardValue
      StandardValueName
      Surplus
      Filter
      LatestOrderNumber
      OfficeID
      BottleCount
      ApplicationID
      Status
      Memo
      SamplingBy
      SamplingPlace
      MountPosition
      DeliveryPeriod
      Quantity
      Price
      Report
      Opinion
      SampleID
      SameCount
      Message
      Discount
      Tax
      Fee
      SampleNumber
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const deleteSample = /* GraphQL */ `
  mutation DeleteSample(
    $input: DeleteSampleInput!
    $condition: ModelSampleConditionInput
  ) {
    deleteSample(input: $input, condition: $condition) {
      id
      SamplingAt
      SamplerName
      MachineID
      Name
      AnalizeTypeGroup
      AnalizeTypeGroupName
      CustomerName
      CustomerMachineID
      MachineCategory
      MachineCategoryText
      MachineType
      MachineTypeText
      Equipment
      MakerID
      MakerText
      ModelNumber
      PurchasedDate
      SystemOil
      SystemOilUnit
      SystemOilUnitText
      MachineMemo
      TotalOperatingTime
      TotalOperatingTimeUnit
      TotalOperatingTimeUnitText
      OperatingTime
      OperatingTimeUnit
      OperatingTimeUnitText
      OverhaulDate
      SinceOverhaulTime
      SinceOverhaulTimeUnit
      SinceOverhaulTimeUnitText
      ParentCustomerMachineID
      ParentEquipment
      ParentMakerID
      ParentMakerText
      ParentModelNumber
      ParentPurchasedDate
      ParentTotalOperatingTime
      ParentTotalOperatingTimeUnit
      ParentTotalOperatingTimeUnitText
      ParentSinceOverhaulTime
      ParentSinceOverhaulTimeUnit
      ParentSinceOverhaulTimeUnitText
      OilmakerID
      OilmakerText
      OilModelNumber
      OilGrade
      OilGradeText
      OilTypeCategory
      OilTypeCategoryText
      OilType
      OilTypeText
      OilProperty
      OilPropertyText
      isHazardousMaterials
      HazardousMaterialsDetail
      HazardousMaterialsConfirmed
      TrackingNumber
      OilChangeDate
      isOilChange
      OilChange
      OilChangeUnit
      OilChangeUnitText
      OilUsageTime
      OilUsageTimeUnit
      OilUsageTimeUnitText
      UseFilter
      FilterUsageTime
      FilterUsageTimeUnit
      FilterUsageTimeUnitText
      OilCondition
      OilConditionText
      AnalizeType
      AnalizeTypeName
      AnalizeSet
      AnalizeSetName
      AnalizeItems
      AnalizeItemNames
      AnalizeItemSub
      AnalizePurpose
      StandardValue
      StandardValueName
      Surplus
      Filter
      LatestOrderNumber
      OfficeID
      BottleCount
      ApplicationID
      Status
      Memo
      SamplingBy
      SamplingPlace
      MountPosition
      DeliveryPeriod
      Quantity
      Price
      Report
      Opinion
      SampleID
      SameCount
      Message
      Discount
      Tax
      Fee
      SampleNumber
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const createApplication = /* GraphQL */ `
  mutation CreateApplication(
    $input: CreateApplicationInput!
    $condition: ModelApplicationConditionInput
  ) {
    createApplication(input: $input, condition: $condition) {
      id
      OrderNumber
      OfficeID
      AnalizeTypeCategory
      Name
      RepCompanyID
      RepOfficeID
      RepEmployeeID
      RepCompany
      RepOffice
      RepDept
      RepPIC
      DelvCompanyID
      DelvOfficeID
      DelvEmployeeID
      DelvCompany
      DelvOffice
      DelvDept
      DelvPIC
      DelvType
      DelvMailTo
      DelivMailCC
      Observation
      PayCompanyID
      PayOfficeID
      PayEmployeeID
      PayCompany
      PayOffice
      PayDept
      PayPIC
      Status
      CustomerOrderNumber
      Shipping
      OrdererID
      OrdererCompanyName
      OrdererOfficeName
      OrdererName
      CustomRepName
      SampleCount
      Price
      Discount
      Fee
      Type
      hasSurplus
      OrdeAt
      IssuedAt
      ValidityAt
      QuoteNumber
      Memo
      Message
      sortKey
      createdAt
      Samples {
        nextToken
        __typename
      }
      updatedAt
      __typename
    }
  }
`;
export const updateApplication = /* GraphQL */ `
  mutation UpdateApplication(
    $input: UpdateApplicationInput!
    $condition: ModelApplicationConditionInput
  ) {
    updateApplication(input: $input, condition: $condition) {
      id
      OrderNumber
      OfficeID
      AnalizeTypeCategory
      Name
      RepCompanyID
      RepOfficeID
      RepEmployeeID
      RepCompany
      RepOffice
      RepDept
      RepPIC
      DelvCompanyID
      DelvOfficeID
      DelvEmployeeID
      DelvCompany
      DelvOffice
      DelvDept
      DelvPIC
      DelvType
      DelvMailTo
      DelivMailCC
      Observation
      PayCompanyID
      PayOfficeID
      PayEmployeeID
      PayCompany
      PayOffice
      PayDept
      PayPIC
      Status
      CustomerOrderNumber
      Shipping
      OrdererID
      OrdererCompanyName
      OrdererOfficeName
      OrdererName
      CustomRepName
      SampleCount
      Price
      Discount
      Fee
      Type
      hasSurplus
      OrdeAt
      IssuedAt
      ValidityAt
      QuoteNumber
      Memo
      Message
      sortKey
      createdAt
      Samples {
        nextToken
        __typename
      }
      updatedAt
      __typename
    }
  }
`;
export const deleteApplication = /* GraphQL */ `
  mutation DeleteApplication(
    $input: DeleteApplicationInput!
    $condition: ModelApplicationConditionInput
  ) {
    deleteApplication(input: $input, condition: $condition) {
      id
      OrderNumber
      OfficeID
      AnalizeTypeCategory
      Name
      RepCompanyID
      RepOfficeID
      RepEmployeeID
      RepCompany
      RepOffice
      RepDept
      RepPIC
      DelvCompanyID
      DelvOfficeID
      DelvEmployeeID
      DelvCompany
      DelvOffice
      DelvDept
      DelvPIC
      DelvType
      DelvMailTo
      DelivMailCC
      Observation
      PayCompanyID
      PayOfficeID
      PayEmployeeID
      PayCompany
      PayOffice
      PayDept
      PayPIC
      Status
      CustomerOrderNumber
      Shipping
      OrdererID
      OrdererCompanyName
      OrdererOfficeName
      OrdererName
      CustomRepName
      SampleCount
      Price
      Discount
      Fee
      Type
      hasSurplus
      OrdeAt
      IssuedAt
      ValidityAt
      QuoteNumber
      Memo
      Message
      sortKey
      createdAt
      Samples {
        nextToken
        __typename
      }
      updatedAt
      __typename
    }
  }
`;
export const createCode = /* GraphQL */ `
  mutation CreateCode(
    $input: CreateCodeInput!
    $condition: ModelCodeConditionInput
  ) {
    createCode(input: $input, condition: $condition) {
      id
      CodeType
      Text
      Value
      Order
      Description
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const updateCode = /* GraphQL */ `
  mutation UpdateCode(
    $input: UpdateCodeInput!
    $condition: ModelCodeConditionInput
  ) {
    updateCode(input: $input, condition: $condition) {
      id
      CodeType
      Text
      Value
      Order
      Description
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const deleteCode = /* GraphQL */ `
  mutation DeleteCode(
    $input: DeleteCodeInput!
    $condition: ModelCodeConditionInput
  ) {
    deleteCode(input: $input, condition: $condition) {
      id
      CodeType
      Text
      Value
      Order
      Description
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const createAnalizeItem = /* GraphQL */ `
  mutation CreateAnalizeItem(
    $input: CreateAnalizeItemInput!
    $condition: ModelAnalizeItemConditionInput
  ) {
    createAnalizeItem(input: $input, condition: $condition) {
      id
      AnalizeType
      Text
      Value
      Price
      Require
      Description
      isActive
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const updateAnalizeItem = /* GraphQL */ `
  mutation UpdateAnalizeItem(
    $input: UpdateAnalizeItemInput!
    $condition: ModelAnalizeItemConditionInput
  ) {
    updateAnalizeItem(input: $input, condition: $condition) {
      id
      AnalizeType
      Text
      Value
      Price
      Require
      Description
      isActive
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const deleteAnalizeItem = /* GraphQL */ `
  mutation DeleteAnalizeItem(
    $input: DeleteAnalizeItemInput!
    $condition: ModelAnalizeItemConditionInput
  ) {
    deleteAnalizeItem(input: $input, condition: $condition) {
      id
      AnalizeType
      Text
      Value
      Price
      Require
      Description
      isActive
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const createAnalizeItemSub = /* GraphQL */ `
  mutation CreateAnalizeItemSub(
    $input: CreateAnalizeItemSubInput!
    $condition: ModelAnalizeItemSubConditionInput
  ) {
    createAnalizeItemSub(input: $input, condition: $condition) {
      id
      AnalizeType
      Parent
      Text
      Value
      Price
      Require
      Description
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const updateAnalizeItemSub = /* GraphQL */ `
  mutation UpdateAnalizeItemSub(
    $input: UpdateAnalizeItemSubInput!
    $condition: ModelAnalizeItemSubConditionInput
  ) {
    updateAnalizeItemSub(input: $input, condition: $condition) {
      id
      AnalizeType
      Parent
      Text
      Value
      Price
      Require
      Description
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const deleteAnalizeItemSub = /* GraphQL */ `
  mutation DeleteAnalizeItemSub(
    $input: DeleteAnalizeItemSubInput!
    $condition: ModelAnalizeItemSubConditionInput
  ) {
    deleteAnalizeItemSub(input: $input, condition: $condition) {
      id
      AnalizeType
      Parent
      Text
      Value
      Price
      Require
      Description
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const createAnalizeItemForCompany = /* GraphQL */ `
  mutation CreateAnalizeItemForCompany(
    $input: CreateAnalizeItemForCompanyInput!
    $condition: ModelAnalizeItemForCompanyConditionInput
  ) {
    createAnalizeItemForCompany(input: $input, condition: $condition) {
      id
      CompanyID
      Value
      Text
      CustomValue
      CustomText
      Price
      Description
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const updateAnalizeItemForCompany = /* GraphQL */ `
  mutation UpdateAnalizeItemForCompany(
    $input: UpdateAnalizeItemForCompanyInput!
    $condition: ModelAnalizeItemForCompanyConditionInput
  ) {
    updateAnalizeItemForCompany(input: $input, condition: $condition) {
      id
      CompanyID
      Value
      Text
      CustomValue
      CustomText
      Price
      Description
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const deleteAnalizeItemForCompany = /* GraphQL */ `
  mutation DeleteAnalizeItemForCompany(
    $input: DeleteAnalizeItemForCompanyInput!
    $condition: ModelAnalizeItemForCompanyConditionInput
  ) {
    deleteAnalizeItemForCompany(input: $input, condition: $condition) {
      id
      CompanyID
      Value
      Text
      CustomValue
      CustomText
      Price
      Description
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const createAnalizeSet = /* GraphQL */ `
  mutation CreateAnalizeSet(
    $input: CreateAnalizeSetInput!
    $condition: ModelAnalizeSetConditionInput
  ) {
    createAnalizeSet(input: $input, condition: $condition) {
      id
      Company
      AnalizeType
      Text
      Value
      Price
      Require
      AnalizeItems
      AnalizeItemNames
      Description
      isActive
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const updateAnalizeSet = /* GraphQL */ `
  mutation UpdateAnalizeSet(
    $input: UpdateAnalizeSetInput!
    $condition: ModelAnalizeSetConditionInput
  ) {
    updateAnalizeSet(input: $input, condition: $condition) {
      id
      Company
      AnalizeType
      Text
      Value
      Price
      Require
      AnalizeItems
      AnalizeItemNames
      Description
      isActive
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const deleteAnalizeSet = /* GraphQL */ `
  mutation DeleteAnalizeSet(
    $input: DeleteAnalizeSetInput!
    $condition: ModelAnalizeSetConditionInput
  ) {
    deleteAnalizeSet(input: $input, condition: $condition) {
      id
      Company
      AnalizeType
      Text
      Value
      Price
      Require
      AnalizeItems
      AnalizeItemNames
      Description
      isActive
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const createAnalizeType = /* GraphQL */ `
  mutation CreateAnalizeType(
    $input: CreateAnalizeTypeInput!
    $condition: ModelAnalizeTypeConditionInput
  ) {
    createAnalizeType(input: $input, condition: $condition) {
      id
      AnalizeTypeGroup
      Value
      Text
      Description
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const updateAnalizeType = /* GraphQL */ `
  mutation UpdateAnalizeType(
    $input: UpdateAnalizeTypeInput!
    $condition: ModelAnalizeTypeConditionInput
  ) {
    updateAnalizeType(input: $input, condition: $condition) {
      id
      AnalizeTypeGroup
      Value
      Text
      Description
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const deleteAnalizeType = /* GraphQL */ `
  mutation DeleteAnalizeType(
    $input: DeleteAnalizeTypeInput!
    $condition: ModelAnalizeTypeConditionInput
  ) {
    deleteAnalizeType(input: $input, condition: $condition) {
      id
      AnalizeTypeGroup
      Value
      Text
      Description
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const createAnalizeTypeGroup = /* GraphQL */ `
  mutation CreateAnalizeTypeGroup(
    $input: CreateAnalizeTypeGroupInput!
    $condition: ModelAnalizeTypeGroupConditionInput
  ) {
    createAnalizeTypeGroup(input: $input, condition: $condition) {
      id
      AnalizeTypeCategory
      Value
      Text
      Order
      Code
      Description
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const updateAnalizeTypeGroup = /* GraphQL */ `
  mutation UpdateAnalizeTypeGroup(
    $input: UpdateAnalizeTypeGroupInput!
    $condition: ModelAnalizeTypeGroupConditionInput
  ) {
    updateAnalizeTypeGroup(input: $input, condition: $condition) {
      id
      AnalizeTypeCategory
      Value
      Text
      Order
      Code
      Description
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const deleteAnalizeTypeGroup = /* GraphQL */ `
  mutation DeleteAnalizeTypeGroup(
    $input: DeleteAnalizeTypeGroupInput!
    $condition: ModelAnalizeTypeGroupConditionInput
  ) {
    deleteAnalizeTypeGroup(input: $input, condition: $condition) {
      id
      AnalizeTypeCategory
      Value
      Text
      Order
      Code
      Description
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const createOilType = /* GraphQL */ `
  mutation CreateOilType(
    $input: CreateOilTypeInput!
    $condition: ModelOilTypeConditionInput
  ) {
    createOilType(input: $input, condition: $condition) {
      id
      OilCategory
      Value
      Text
      isHazardousMaterials
      isAccept
      Order
      Description
      Properties
      Caution
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const updateOilType = /* GraphQL */ `
  mutation UpdateOilType(
    $input: UpdateOilTypeInput!
    $condition: ModelOilTypeConditionInput
  ) {
    updateOilType(input: $input, condition: $condition) {
      id
      OilCategory
      Value
      Text
      isHazardousMaterials
      isAccept
      Order
      Description
      Properties
      Caution
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const deleteOilType = /* GraphQL */ `
  mutation DeleteOilType(
    $input: DeleteOilTypeInput!
    $condition: ModelOilTypeConditionInput
  ) {
    deleteOilType(input: $input, condition: $condition) {
      id
      OilCategory
      Value
      Text
      isHazardousMaterials
      isAccept
      Order
      Description
      Properties
      Caution
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const createStandardValue = /* GraphQL */ `
  mutation CreateStandardValue(
    $input: CreateStandardValueInput!
    $condition: ModelStandardValueConditionInput
  ) {
    createStandardValue(input: $input, condition: $condition) {
      id
      OfficeID
      AnalizeType
      Text
      Value
      StandardValue
      Description
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const updateStandardValue = /* GraphQL */ `
  mutation UpdateStandardValue(
    $input: UpdateStandardValueInput!
    $condition: ModelStandardValueConditionInput
  ) {
    updateStandardValue(input: $input, condition: $condition) {
      id
      OfficeID
      AnalizeType
      Text
      Value
      StandardValue
      Description
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const deleteStandardValue = /* GraphQL */ `
  mutation DeleteStandardValue(
    $input: DeleteStandardValueInput!
    $condition: ModelStandardValueConditionInput
  ) {
    deleteStandardValue(input: $input, condition: $condition) {
      id
      OfficeID
      AnalizeType
      Text
      Value
      StandardValue
      Description
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const createCompany = /* GraphQL */ `
  mutation CreateCompany(
    $input: CreateCompanyInput!
    $condition: ModelCompanyConditionInput
  ) {
    createCompany(input: $input, condition: $condition) {
      id
      CompanyID
      Name
      NameKana
      Nickname
      Country
      Pref
      Zip
      Address1
      Address2
      Address3
      Tel
      FAX
      Represent
      RepresentPosition
      PIC
      PICDept
      PICContact
      Ratio
      PaymentCompanyID
      PaymentOfficeID
      PaymenyType
      Rounding
      Taxation
      AnalizeTypeGroup
      isActive
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const updateCompany = /* GraphQL */ `
  mutation UpdateCompany(
    $input: UpdateCompanyInput!
    $condition: ModelCompanyConditionInput
  ) {
    updateCompany(input: $input, condition: $condition) {
      id
      CompanyID
      Name
      NameKana
      Nickname
      Country
      Pref
      Zip
      Address1
      Address2
      Address3
      Tel
      FAX
      Represent
      RepresentPosition
      PIC
      PICDept
      PICContact
      Ratio
      PaymentCompanyID
      PaymentOfficeID
      PaymenyType
      Rounding
      Taxation
      AnalizeTypeGroup
      isActive
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const deleteCompany = /* GraphQL */ `
  mutation DeleteCompany(
    $input: DeleteCompanyInput!
    $condition: ModelCompanyConditionInput
  ) {
    deleteCompany(input: $input, condition: $condition) {
      id
      CompanyID
      Name
      NameKana
      Nickname
      Country
      Pref
      Zip
      Address1
      Address2
      Address3
      Tel
      FAX
      Represent
      RepresentPosition
      PIC
      PICDept
      PICContact
      Ratio
      PaymentCompanyID
      PaymentOfficeID
      PaymenyType
      Rounding
      Taxation
      AnalizeTypeGroup
      isActive
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const createOffice = /* GraphQL */ `
  mutation CreateOffice(
    $input: CreateOfficeInput!
    $condition: ModelOfficeConditionInput
  ) {
    createOffice(input: $input, condition: $condition) {
      id
      CompanyID
      CompanyName
      OfficeID
      Name
      NameKana
      Nickname
      Country
      Pref
      Zip
      Address1
      Address2
      Address3
      Tel
      FAX
      Represent
      PICID
      PIC
      PICDept
      PICContact
      PICemail
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const updateOffice = /* GraphQL */ `
  mutation UpdateOffice(
    $input: UpdateOfficeInput!
    $condition: ModelOfficeConditionInput
  ) {
    updateOffice(input: $input, condition: $condition) {
      id
      CompanyID
      CompanyName
      OfficeID
      Name
      NameKana
      Nickname
      Country
      Pref
      Zip
      Address1
      Address2
      Address3
      Tel
      FAX
      Represent
      PICID
      PIC
      PICDept
      PICContact
      PICemail
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const deleteOffice = /* GraphQL */ `
  mutation DeleteOffice(
    $input: DeleteOfficeInput!
    $condition: ModelOfficeConditionInput
  ) {
    deleteOffice(input: $input, condition: $condition) {
      id
      CompanyID
      CompanyName
      OfficeID
      Name
      NameKana
      Nickname
      Country
      Pref
      Zip
      Address1
      Address2
      Address3
      Tel
      FAX
      Represent
      PICID
      PIC
      PICDept
      PICContact
      PICemail
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const createEmployee = /* GraphQL */ `
  mutation CreateEmployee(
    $input: CreateEmployeeInput!
    $condition: ModelEmployeeConditionInput
  ) {
    createEmployee(input: $input, condition: $condition) {
      id
      EmployeeID
      CompanyID
      OfficeID
      Name
      NameKana
      CompanyName
      OfficeName
      Tel
      Mobile
      FAX
      DeptName
      Position
      email
      Permission
      UserPoolID
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const updateEmployee = /* GraphQL */ `
  mutation UpdateEmployee(
    $input: UpdateEmployeeInput!
    $condition: ModelEmployeeConditionInput
  ) {
    updateEmployee(input: $input, condition: $condition) {
      id
      EmployeeID
      CompanyID
      OfficeID
      Name
      NameKana
      CompanyName
      OfficeName
      Tel
      Mobile
      FAX
      DeptName
      Position
      email
      Permission
      UserPoolID
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const deleteEmployee = /* GraphQL */ `
  mutation DeleteEmployee(
    $input: DeleteEmployeeInput!
    $condition: ModelEmployeeConditionInput
  ) {
    deleteEmployee(input: $input, condition: $condition) {
      id
      EmployeeID
      CompanyID
      OfficeID
      Name
      NameKana
      CompanyName
      OfficeName
      Tel
      Mobile
      FAX
      DeptName
      Position
      email
      Permission
      UserPoolID
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const createInformation = /* GraphQL */ `
  mutation CreateInformation(
    $input: CreateInformationInput!
    $condition: ModelInformationConditionInput
  ) {
    createInformation(input: $input, condition: $condition) {
      id
      Type
      Message
      Detail
      NoticeFrom
      NoticeTo
      Order
      isActive
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const updateInformation = /* GraphQL */ `
  mutation UpdateInformation(
    $input: UpdateInformationInput!
    $condition: ModelInformationConditionInput
  ) {
    updateInformation(input: $input, condition: $condition) {
      id
      Type
      Message
      Detail
      NoticeFrom
      NoticeTo
      Order
      isActive
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const deleteInformation = /* GraphQL */ `
  mutation DeleteInformation(
    $input: DeleteInformationInput!
    $condition: ModelInformationConditionInput
  ) {
    deleteInformation(input: $input, condition: $condition) {
      id
      Type
      Message
      Detail
      NoticeFrom
      NoticeTo
      Order
      isActive
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const createFAQ = /* GraphQL */ `
  mutation CreateFAQ(
    $input: CreateFAQInput!
    $condition: ModelFAQConditionInput
  ) {
    createFAQ(input: $input, condition: $condition) {
      id
      Category
      Question
      Answer
      isActive
      Order
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const updateFAQ = /* GraphQL */ `
  mutation UpdateFAQ(
    $input: UpdateFAQInput!
    $condition: ModelFAQConditionInput
  ) {
    updateFAQ(input: $input, condition: $condition) {
      id
      Category
      Question
      Answer
      isActive
      Order
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const deleteFAQ = /* GraphQL */ `
  mutation DeleteFAQ(
    $input: DeleteFAQInput!
    $condition: ModelFAQConditionInput
  ) {
    deleteFAQ(input: $input, condition: $condition) {
      id
      Category
      Question
      Answer
      isActive
      Order
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const createConfigure = /* GraphQL */ `
  mutation CreateConfigure(
    $input: CreateConfigureInput!
    $condition: ModelConfigureConditionInput
  ) {
    createConfigure(input: $input, condition: $condition) {
      id
      Key
      Value
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const updateConfigure = /* GraphQL */ `
  mutation UpdateConfigure(
    $input: UpdateConfigureInput!
    $condition: ModelConfigureConditionInput
  ) {
    updateConfigure(input: $input, condition: $condition) {
      id
      Key
      Value
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const deleteConfigure = /* GraphQL */ `
  mutation DeleteConfigure(
    $input: DeleteConfigureInput!
    $condition: ModelConfigureConditionInput
  ) {
    deleteConfigure(input: $input, condition: $condition) {
      id
      Key
      Value
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const createOutbox = /* GraphQL */ `
  mutation CreateOutbox(
    $input: CreateOutboxInput!
    $condition: ModelOutboxConditionInput
  ) {
    createOutbox(input: $input, condition: $condition) {
      id
      Type
      From
      To
      CC
      Subject
      Body
      Status
      Sending
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const updateOutbox = /* GraphQL */ `
  mutation UpdateOutbox(
    $input: UpdateOutboxInput!
    $condition: ModelOutboxConditionInput
  ) {
    updateOutbox(input: $input, condition: $condition) {
      id
      Type
      From
      To
      CC
      Subject
      Body
      Status
      Sending
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const deleteOutbox = /* GraphQL */ `
  mutation DeleteOutbox(
    $input: DeleteOutboxInput!
    $condition: ModelOutboxConditionInput
  ) {
    deleteOutbox(input: $input, condition: $condition) {
      id
      Type
      From
      To
      CC
      Subject
      Body
      Status
      Sending
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const createCampaign = /* GraphQL */ `
  mutation CreateCampaign(
    $input: CreateCampaignInput!
    $condition: ModelCampaignConditionInput
  ) {
    createCampaign(input: $input, condition: $condition) {
      id
      Name
      Description
      Discount
      From
      To
      isActive
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const updateCampaign = /* GraphQL */ `
  mutation UpdateCampaign(
    $input: UpdateCampaignInput!
    $condition: ModelCampaignConditionInput
  ) {
    updateCampaign(input: $input, condition: $condition) {
      id
      Name
      Description
      Discount
      From
      To
      isActive
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const deleteCampaign = /* GraphQL */ `
  mutation DeleteCampaign(
    $input: DeleteCampaignInput!
    $condition: ModelCampaignConditionInput
  ) {
    deleteCampaign(input: $input, condition: $condition) {
      id
      Name
      Description
      Discount
      From
      To
      isActive
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const createHolder = /* GraphQL */ `
  mutation CreateHolder(
    $input: CreateHolderInput!
    $condition: ModelHolderConditionInput
  ) {
    createHolder(input: $input, condition: $condition) {
      id
      Value
      Text
      TextEn
      Nickname
      Price
      Require
      TestingMethod
      Description
      at1001
      at1002
      at1003
      at1004
      at1005
      at1101
      at1102
      at1103
      at1104
      at1105
      at2001
      at3001
      at3002
      at3003
      at3101
      at3102
      at3103
      isActive
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const updateHolder = /* GraphQL */ `
  mutation UpdateHolder(
    $input: UpdateHolderInput!
    $condition: ModelHolderConditionInput
  ) {
    updateHolder(input: $input, condition: $condition) {
      id
      Value
      Text
      TextEn
      Nickname
      Price
      Require
      TestingMethod
      Description
      at1001
      at1002
      at1003
      at1004
      at1005
      at1101
      at1102
      at1103
      at1104
      at1105
      at2001
      at3001
      at3002
      at3003
      at3101
      at3102
      at3103
      isActive
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const deleteHolder = /* GraphQL */ `
  mutation DeleteHolder(
    $input: DeleteHolderInput!
    $condition: ModelHolderConditionInput
  ) {
    deleteHolder(input: $input, condition: $condition) {
      id
      Value
      Text
      TextEn
      Nickname
      Price
      Require
      TestingMethod
      Description
      at1001
      at1002
      at1003
      at1004
      at1005
      at1101
      at1102
      at1103
      at1104
      at1105
      at2001
      at3001
      at3002
      at3003
      at3101
      at3102
      at3103
      isActive
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const createProtocol = /* GraphQL */ `
  mutation CreateProtocol(
    $input: CreateProtocolInput!
    $condition: ModelProtocolConditionInput
  ) {
    createProtocol(input: $input, condition: $condition) {
      id
      Value
      Text
      Price
      Holders
      HolderNames
      Require
      Description
      at1001
      at1002
      at1003
      at1004
      at1005
      at1101
      at1102
      at1103
      at1104
      at1105
      at2001
      at3001
      at3002
      at3003
      at3101
      at3102
      at3103
      isActive
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const updateProtocol = /* GraphQL */ `
  mutation UpdateProtocol(
    $input: UpdateProtocolInput!
    $condition: ModelProtocolConditionInput
  ) {
    updateProtocol(input: $input, condition: $condition) {
      id
      Value
      Text
      Price
      Holders
      HolderNames
      Require
      Description
      at1001
      at1002
      at1003
      at1004
      at1005
      at1101
      at1102
      at1103
      at1104
      at1105
      at2001
      at3001
      at3002
      at3003
      at3101
      at3102
      at3103
      isActive
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const deleteProtocol = /* GraphQL */ `
  mutation DeleteProtocol(
    $input: DeleteProtocolInput!
    $condition: ModelProtocolConditionInput
  ) {
    deleteProtocol(input: $input, condition: $condition) {
      id
      Value
      Text
      Price
      Holders
      HolderNames
      Require
      Description
      at1001
      at1002
      at1003
      at1004
      at1005
      at1101
      at1102
      at1103
      at1104
      at1105
      at2001
      at3001
      at3002
      at3003
      at3101
      at3102
      at3103
      isActive
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const createDeliverables = /* GraphQL */ `
  mutation CreateDeliverables(
    $input: CreateDeliverablesInput!
    $condition: ModelDeliverablesConditionInput
  ) {
    createDeliverables(input: $input, condition: $condition) {
      id
      ApplicationID
      OrderNumber
      CompanyID
      OfficeID
      Company
      Office
      Dept
      PIC
      email
      MachineID
      SampleRecordID
      SampleID
      SampleNumber
      SampleName
      ReportNumber
      ReportVersion
      InReviewReportNumber
      InReviewReportVersion
      FileName
      Type
      DownloadAt
      DownloadUser
      DownloadCount
      DownloadDeadline
      Status
      Memo
      isAdcive
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const updateDeliverables = /* GraphQL */ `
  mutation UpdateDeliverables(
    $input: UpdateDeliverablesInput!
    $condition: ModelDeliverablesConditionInput
  ) {
    updateDeliverables(input: $input, condition: $condition) {
      id
      ApplicationID
      OrderNumber
      CompanyID
      OfficeID
      Company
      Office
      Dept
      PIC
      email
      MachineID
      SampleRecordID
      SampleID
      SampleNumber
      SampleName
      ReportNumber
      ReportVersion
      InReviewReportNumber
      InReviewReportVersion
      FileName
      Type
      DownloadAt
      DownloadUser
      DownloadCount
      DownloadDeadline
      Status
      Memo
      isAdcive
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const deleteDeliverables = /* GraphQL */ `
  mutation DeleteDeliverables(
    $input: DeleteDeliverablesInput!
    $condition: ModelDeliverablesConditionInput
  ) {
    deleteDeliverables(input: $input, condition: $condition) {
      id
      ApplicationID
      OrderNumber
      CompanyID
      OfficeID
      Company
      Office
      Dept
      PIC
      email
      MachineID
      SampleRecordID
      SampleID
      SampleNumber
      SampleName
      ReportNumber
      ReportVersion
      InReviewReportNumber
      InReviewReportVersion
      FileName
      Type
      DownloadAt
      DownloadUser
      DownloadCount
      DownloadDeadline
      Status
      Memo
      isAdcive
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const createDownLoadHistory = /* GraphQL */ `
  mutation CreateDownLoadHistory(
    $input: CreateDownLoadHistoryInput!
    $condition: ModelDownLoadHistoryConditionInput
  ) {
    createDownLoadHistory(input: $input, condition: $condition) {
      id
      DeliverablesID
      DownloadAt
      DownloadUser
      Type
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const updateDownLoadHistory = /* GraphQL */ `
  mutation UpdateDownLoadHistory(
    $input: UpdateDownLoadHistoryInput!
    $condition: ModelDownLoadHistoryConditionInput
  ) {
    updateDownLoadHistory(input: $input, condition: $condition) {
      id
      DeliverablesID
      DownloadAt
      DownloadUser
      Type
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const deleteDownLoadHistory = /* GraphQL */ `
  mutation DeleteDownLoadHistory(
    $input: DeleteDownLoadHistoryInput!
    $condition: ModelDownLoadHistoryConditionInput
  ) {
    deleteDownLoadHistory(input: $input, condition: $condition) {
      id
      DeliverablesID
      DownloadAt
      DownloadUser
      Type
      createdAt
      updatedAt
      __typename
    }
  }
`;
